import mutations from './mutations';
import actions from './actions';
import state from './state';

export default {
  mutations,
  actions,
  state,
  namespaced: true,
};
